<template>
<div class="row">
<div class="col-1-of-3" v-for="(month, index) of months" :key="index">
    <div class="monthly-card">
      <div class="monthly-card-top">
        <h1 class="monthly-card-top-header">{{month['name']}}</h1>
      </div>
      <div class="monthly-card-bottom">
        <table class="monthly-card-bottom-table">
          <tr class="monthly-card-bottom-table-tr">
            <td>Fajr</td>
            <td>{{zeroPadding(month['fajr']['hour'])}}:{{zeroPadding(month['fajr']['minute'])}}</td>
          </tr>
          <tr class="monthly-card-bottom-table-tr">
            <td>Zuhr</td>
            <td>{{zeroPadding(month['zuhr']['hour'])}}:{{zeroPadding(month['zuhr']['minute'])}}</td>
          </tr>
          <tr class="monthly-card-bottom-table-tr">
            <td>Asr</td>
            <td>{{zeroPadding(month['asr']['hour'])}}:{{zeroPadding(month['asr']['minute'])}}</td>
          </tr>
          <tr class="monthly-card-bottom-table-tr">
            <td>Magrib</td>
            <td>{{zeroPadding(month['magrib']['hour'])}}:{{zeroPadding(month['magrib']['minute'])}}</td>
          </tr>
          <tr class="monthly-card-bottom-table-tr">
            <td>Isha</td>
            <td>{{zeroPadding(month['isha']['hour'])}}:{{zeroPadding(month['isha']['minute'])}}</td>
          </tr>
        </table>
        <div class="monthly-card-footer">
          <router-link class="btn btn-green" :id="month['name']" :to="`/${month['name'].toLowerCase()}`">load more &rarr;</router-link>
        </div>
      </div>
    </div>
    </div>
    </div>
</template>
<script>
export default {
    props: ['months'],
  methods: {
    zeroPadding(value) {
      return value < 10 ? "0" + value : value;
    },
    generateLink(value){
        return `/${value.toLowerCase()}`;
    }
  }
};
</script>